export default (config) => {
  var domain = getMainDomain()
  config.files.staticServer = config.files.staticServer.replace('$DOMAIN', domain)
  config.files.thumbServer = config.files.thumbServer.replace('$DOMAIN', domain)
  config.files.noImageUrl = config.files.noImageUrl.replace('$DOMAIN', domain)
  config.files.watermarkUrl = config.files.watermarkUrl.replace('$DOMAIN', domain)
  config.apiServer = config.apiServer.replace('$DOMAIN', domain)
  config.websiteUrl = config.websiteUrl.replace('$DOMAIN', domain)
  // ---
  config.apiServerUrl = (config.ssl ? 'https://' : 'http://') + config.apiServer
  config.files.staticServerUrl = (config.ssl ? 'https://' : 'http://') + config.files.staticServer
  config.files.thumbServerUrl = (config.ssl ? 'https://' : 'http://') + config.files.thumbServer

  return config
}

function getMainDomain () {
  var domain = window.location.host;

  const dots = domain.match(/\./g)
  var dotsCount = dots && dots.length

  if (dotsCount > 1) {
    const firstDotIndex = domain.indexOf('.')
    domain = domain.substr(firstDotIndex + 1)
  }

  return domain
}
